import CustomLoader from "@/components/common/loader/SpinnerLoader";
import { UserTierType } from "@/constants/enums/user-tier-type.enum";
import EditMyAccount from "@/pages/EditMyAccount";
import { RootState } from "@/store";
import BackIcon from "@styles/all-images/icons/back-button.svg";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
const CompleteProfile: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.auth.user);

  const handleSubmit = () => {
    if (!user) {
      return;
    }
    const currentPathName = window.location.pathname;
    const redirectUrl =
      user.user_type.id === UserTierType.Tier4
        ? `/t4/onboarding-profile?from=${currentPathName}`
        : "/dashboard";
    navigate(redirectUrl);
  };

  if (isLoading) {
    return (
      <div className="tw-flex tw-justify-center tw-items-center tw-h-screen">
        <CustomLoader loading={true} isWrapper={true} size="50" />
      </div>
    );
  }
  return (
    <div className="tw-relative">
      <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-w-full tw-z-10">
        <div className="tw-px-8 tw-py-4 tw-bg-white tw-border-b border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center">
              <a href="/my-account">
                <img src={BackIcon} alt="Back Icon" />{" "}
              </a>
              <h1 className="tw-text-xl tw-ml-4 tw-font-semibold font-primary-color">
                Your Profile
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className="tw-bg-white tw-px-8 tw-pt-4 tw-pb-4">
        <div className="tw-mt-[127px] tw-bg-[#F8FAFC] tw-rounded-lg">
          <div className="tw-px-4">
            <EditMyAccount
              hideDefaultHeader={true}
              customSubmitHandler={handleSubmit}
              className="tw-space-y-4"
              isRequest={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompleteProfile;
